/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-submit-button",
  templateUrl: "./submit-button.component.html",
  styleUrls: ["./submit-button.component.scss"],
})
export class SubmitButtonComponent implements OnInit {
  @Input() buttontext: string;
  @Output() click = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}
}
